module.exports = __webpack_public_path__ + "57023915e931d6b7cf5cca6945bfbca5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/as_you_sow_2024_chart.png
// module id = 1632
// module chunks = 0